import React, { useState, useEffect } from 'react';
import api from '@/lib/api';

const FooterEditor = () => {
    const [content, setContent] = useState({
        copyrightText: '',
        privacyPolicyUrl: '',
        termsUrl: ''
    });
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState('');

    useEffect(() => {
        const fetchContent = async () => {
            try {
                const { data } = await api.get('/sections/Footer');
                if (data && data.content) {
                    const contentMap = {};
                    data.content.forEach(item => contentMap[item.key] = item.value);
                    setContent(prev => ({ ...prev, ...contentMap }));
                }
                setLoading(false);
            } catch (error) {
                console.error(error);
                setLoading(false);
            }
        };
        fetchContent();
    }, []);

    const handleChange = (e) => {
        setContent({ ...content, [e.target.name]: e.target.value });
    };

    const handleSave = async () => {
        try {
            const contentArray = Object.keys(content).map(key => ({
                key, type: 'text', value: content[key]
            }));
            await api.put('/sections/Footer', { content: contentArray });
            setMessage('Footer updated successfully!');
            setTimeout(() => setMessage(''), 3000);
        } catch (error) {
            setMessage('Error saving footer');
        }
    };

    if (loading) return <div>Loading...</div>;

    return (
        <div className="max-w-4xl mx-auto bg-white p-8 rounded shadow text-gray-900">
            <h2 className="text-2xl font-bold mb-6">Edit Footer Section</h2>
            {message && <div className={`p-4 mb-4 rounded ${message.includes('Error') ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>{message}</div>}

            <div className="space-y-6">
                <div>
                    <label className="block text-sm font-medium text-gray-700">Copyright Text</label>
                    <input
                        type="text" name="copyrightText" value={content.copyrightText} onChange={handleChange}
                        className="w-full mt-1 p-2 border rounded"
                        placeholder="e.g. 2024 SNC AI Solutions. All rights reserved."
                    />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Privacy Policy URL</label>
                        <input
                            type="text" name="privacyPolicyUrl" value={content.privacyPolicyUrl} onChange={handleChange}
                            className="w-full mt-1 p-2 border rounded"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Terms of Service URL</label>
                        <input
                            type="text" name="termsUrl" value={content.termsUrl} onChange={handleChange}
                            className="w-full mt-1 p-2 border rounded"
                        />
                    </div>
                </div>

                <button onClick={handleSave} className="px-6 py-2 bg-black text-white rounded hover:bg-gray-800">
                    Save Changes
                </button>
            </div>
        </div>
    );
};

export default FooterEditor;
